import { EmailDesign } from "@/stores/emailBuilderStore";

export const DefaultCancelledRecurringScheduleEmail = (design: EmailDesign) => {
    return {
        page: {
            body: {
                container: {
                    style: {
                        "background-color": "#FFFFFF",
                    },
                },
                content: {
                    computedStyle: {
                        align: "center",
                        linkColor: "#0015ADE8",
                        messageBackgroundColor: "transparent",
                        messageWidth: "600px",
                    },
                    style: {
                        color: "#000000",
                        "font-family":
                            "'Helvetica Neue', Helvetica, Arial, sans-serif",
                    },
                },
                webFonts: [],
            },
            description: "",
            rows: [
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnAmp: false,
                                            hideContentOnDesktop: false,
                                            hideContentOnHtml: false,
                                            hideContentOnMobile: false,
                                        },
                                        html: {
                                            html: `<img src="${design.logoUrl}" alt="Organization Logo" style="width:25%;" />`,
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-html",
                                    uuid: "198acb3b-6da2-4478-a128-4d79c7ec8382",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "35px",
                            },
                            uuid: "2f79c11f-6b33-46e5-b839-ac808929a935",
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                        },
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "0px",
                            "border-right": "0px solid transparent",
                            "border-top": "0px solid transparent",
                            color: "#000000",
                            width: "600px",
                        },
                    },
                    empty: false,
                    locked: false,
                    synced: false,
                    type: "one-column-empty",
                    uuid: "09dfc2cd-95fa-4349-94cd-53261ee19a3c",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "25px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:16px;font-family:inherit;" data-mce-style="font-size:14px;line-height:16px;font-family:inherit;"><p style="font-size:14px;line-height:16px;word-break:break-word;" data-mce-style="font-size:14px;line-height:16px;word-break:break-word;"><span style="font-size:26px;line-height:31px;" data-mce-style="font-size:26px;line-height:31px;">Your recurring schedule was cancelled.</span></p></div>',
                                            style: {
                                                color: "#333333",
                                                "font-family": "inherit",
                                                "line-height": "120%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "0e94d63f-af8c-4269-bf24-e382454bc634",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            align: "center",
                                            hideContentOnMobile: false,
                                        },
                                        divider: {
                                            style: {
                                                "border-top":
                                                    "1px solid #DADADA",
                                                width: "100%",
                                            },
                                        },
                                        style: {
                                            "padding-bottom": "25px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "40px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-divider",
                                    uuid: "f22d17b9-d7cc-4833-9860-9317cd65005c",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:21px;font-family:&#39;Helvetica Neue&#39;, Helvetica, Arial, sans-serif;" data-mce-style="font-size:14px;line-height:21px;font-family:&#39;Helvetica Neue&#39;, Helvetica, Arial, sans-serif;"><p style="line-height:18px;word-break:break-word;text-align:left;" data-renderer-start-pos="8929" data-mce-style="line-height:18px;word-break:break-word;text-align:left;"><span style="font-size:16px;line-height:24px;" data-mce-style="font-size:16px;line-height:24px;">This email is to confirm that your recurring schedule has been cancelled, and will no longer process recurring gifts. If this was done in error, please contact us.</span></p></div>',
                                            style: {
                                                color: "#555555",
                                                "font-family":
                                                    "'Helvetica Neue', Helvetica, Arial, sans-serif",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "d28dcb24-8ac4-4396-83ab-4eed96cb907f",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "20px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "10px",
                            },
                            uuid: "ba131842-52de-4bb1-be33-95e730519a67",
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                        },
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "0px",
                            "border-right": "0px solid transparent",
                            "border-top": "0px solid transparent",
                            color: "#000000",
                            width: "600px",
                        },
                    },
                    empty: false,
                    locked: false,
                    synced: false,
                    type: "one-column-empty",
                    uuid: "dce260e1-60d0-4b37-b1be-bbef7b056646",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:16px;font-family:inherit;" data-mce-style="font-size:14px;line-height:16px;font-family:inherit;"><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="12544" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong data-renderer-mark="true">Organization Name</strong></span></p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="12563" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{OrganizationName}}</span></p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="12563" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;">&nbsp;</p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="12585" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong data-renderer-mark="true">Recurring Gift Status</strong></span></p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="12608" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{RecurringGiftStatus}}</span></p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="12633" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;">&nbsp;</p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="12633" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong data-renderer-mark="true">Gift Amount </strong></span></p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="12647" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{RecurringGiftAmount}}</span></p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="12672" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;">&nbsp;</p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="12672" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong data-renderer-mark="true">Payment Method</strong></span></p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="12672" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{RecurringGiftPaymentLast4}}</span></p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="12719" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;">&nbsp;</p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="12719" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong data-renderer-mark="true">Project Allocation(s)</strong></span></p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="12742" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{RecurringGiftProjects}}</span></p></div>',
                                            style: {
                                                color: "#6f6f6f",
                                                "font-family": "inherit",
                                                "line-height": "120%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "309ab5cc-c73c-4162-a3b0-572061541650",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "35px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "25px",
                            },
                            uuid: "75a59b57-c068-44f5-b1aa-f2aa9fa3f80d",
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                        },
                        style: {
                            "background-color": "#fafafa",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "20px",
                            "border-right": "0px solid transparent",
                            "border-top": "0px solid transparent",
                            color: "#000000",
                            width: "600px",
                        },
                    },
                    empty: false,
                    locked: false,
                    synced: false,
                    type: "one-column-empty",
                    uuid: "c04c5e8e-9afb-4db7-89f3-5ca9bc814ba6",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            align: "center",
                                            hideContentOnMobile: false,
                                        },
                                        divider: {
                                            style: {
                                                "border-top":
                                                    "1px solid #DADADA",
                                                width: "100%",
                                            },
                                        },
                                        style: {
                                            "padding-bottom": "35px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "45px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-divider",
                                    uuid: "31683d97-b138-44e9-ac65-385e79aefbd8",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "7px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:16px;font-family:inherit;" data-mce-style="font-size:14px;line-height:16px;font-family:inherit;"><p style="font-size:14px;line-height:16px;word-break:break-word;" data-mce-style="font-size:14px;line-height:16px;word-break:break-word;"><span style="font-size:18px;line-height:21px;" data-mce-style="font-size:18px;line-height:21px;">Manage Your Donation</span></p></div>',
                                            style: {
                                                color: "#333333",
                                                "font-family": "inherit",
                                                "line-height": "120%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "dba137ca-2bdf-44f1-aeae-360e1edea2ff",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:21px;font-family:inherit;" data-mce-style="font-size:14px;line-height:21px;font-family:inherit;"><p style="line-height:18px;word-break:break-word;text-align:left;" data-renderer-start-pos="9306" data-mce-style="line-height:18px;word-break:break-word;text-align:left;"><span style="font-size:15px;line-height:22px;" data-mce-style="font-size:15px;line-height:22px;">Easily update your contact information, make changes to your recurring gift, and have receipts resent to you by email.</span></p></div>',
                                            style: {
                                                color: "#555555",
                                                "font-family": "inherit",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "776be9d9-c1e6-42e4-b960-1bbde672e09a",
                                },
                                {
                                    descriptor: {
                                        button: {
                                            href: "{{DonorPortalLogin}}",
                                            label: '<div class="txtTinyMce-wrapper" style="" data-mce-style=""><p dir="ltr" style="word-break: break-word;" data-mce-style="word-break: break-word;">Donor Portal Login</p></div>',
                                            style: {
                                                "background-color": "#333333",
                                                "border-bottom":
                                                    "0px solid transparent",
                                                "border-left":
                                                    "0px solid transparent",
                                                "border-radius": "30px",
                                                "border-right":
                                                    "0px solid transparent",
                                                "border-top":
                                                    "0px solid transparent",
                                                color: "#FFFFFF",
                                                direction: "ltr",
                                                "font-family": "inherit",
                                                "font-size": "15px",
                                                "font-weight": "400",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "35px",
                                                "padding-right": "35px",
                                                "padding-top": "5px",
                                                width: "auto",
                                            },
                                            target: "_blank",
                                        },
                                        computedStyle: {
                                            height: 40,
                                            hideContentOnMobile: false,
                                            width: 196,
                                        },
                                        style: {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px",
                                            "text-align": "left",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-button",
                                    uuid: "40b82f13-b2c5-46e2-8b4c-942442fee415",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            align: "center",
                                            hideContentOnMobile: false,
                                        },
                                        divider: {
                                            style: {
                                                "border-top":
                                                    "1px solid #DADADA",
                                                width: "100%",
                                            },
                                        },
                                        style: {
                                            "padding-bottom": "25px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "35px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-divider",
                                    uuid: "5b4c17b9-e920-4af3-ae97-a2f47644e1ba",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px",
                            },
                            uuid: "94e92b72-be2e-4c0c-a42d-98473bb6767c",
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                        },
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "0px",
                            "border-right": "0px solid transparent",
                            "border-top": "0px solid transparent",
                            color: "#000000",
                            width: "600px",
                        },
                    },
                    empty: false,
                    locked: false,
                    synced: false,
                    type: "one-column-empty",
                    uuid: "8242c5e4-c90c-4dbb-9140-386a28283b70",
                },
            ],
            template: {
                version: "2.0.0",
            },
            title: "",
        },
        comments: {},
    };
};
